var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00B897"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20C28 20.5523 27.5523 21 27 21H21V27C21 27.5523 20.5523 28 20 28C19.4477 28 19 27.5523 19 27V21H13C12.4477 21 12 20.5523 12 20C12 19.4477 12.4477 19 13 19H19V13C19 12.4477 19.4477 12 20 12C20.5523 12 21 12.4477 21 13V19H27C27.5523 19 28 19.4477 28 20Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncome);
export default __webpack_public_path__ + "static/media/income.cd473cd5f196497d9e8f6f35fd29d181.svg";
export { ForwardRef as ReactComponent };